<header
  class="header"
  [class.header--content-fixed]="isContentFixed"
  [class.header--mobile-nav-open]="mobileNavOpen"
  (click)="closeProfileMenu($event, headerContent)">
  <!-- header phone info -->
  <section class="header__top-info" #topInfo>
    <!-- tell section -->
    <a [href]="companyPhoneTel" class="tell-section">
      <i class="iconsax tell-section__tell-icon" icon-name="phone"></i>
      <span class="tell-section__tell-container">
        <span class="tell-section__tell-prefix">+44</span>
        <span class="tell-section__tell-value">{{ companyPhoneLocal }}</span>
      </span>
    </a>

    <!-- languages menu hidden -->
    <!--
    <ul class="languages-menu" dir="rtl">
      @for (lang of languagesMenuItems; track lang?.id) {
        <li
          class="languages-menu__lang-item"
          [ngClass]="{
            'languages-menu__lang-item--active': selectedLang === lang.code,
          }"
          (click)="setLang(lang.code)">
          {{ lang?.name }}
        </li>
      }
    </ul>
    -->
  </section>

  <section
    class="header__content-container"
    #contentContainer
    [class.header__content-container--fixed]="isContentFixed">
    <!-- header content section - logo & menu & login btns -->
    <div class="header__content" (mouseleave)="toggleMegaMenu()" #headerContent>
      <!-- header logo -->
      <a class="header__logo" routerLink="">
        <img
          class="logo-image"
          ngSrc="assets/icons/logo-wejoiner.png"
          alt="weJoiner"
          height="512"
          width="512" />
      </a>
      <!-- header menu -->
      <div
        id="main-navigation"
        class="header-menu"
        role="navigation"
        aria-label="Main">
        <div class="header-menu__mobile-head">
          <span class="header-menu__mobile-title">{{
            'header.menu' | translate
          }}</span>
          <button
            type="button"
            class="header-menu__mobile-close"
            (click)="closeMobileNav()"
            [attr.aria-label]="'global.close' | translate">
            <span class="header-menu__mobile-close-text">X</span>
          </button>
        </div>
        <!-- main menu row -->
        <ul class="header-menu__main">
          @for (item of mainMenu; track item) {
            <li
              class="header-menu__item"
              [class.header-menu__item--has-dropdown]="item.children?.length"
              [class.header-menu__item--active]="isMenuItemActive(item)"
              [class.header-menu__item--mobile-sub-open]="
                isMobileSubmenuOpen(item)
              "
              (mouseover)="!item.children?.length && toggleMegaMenu(item.link)"
              (mouseleave)="!item.children?.length && toggleMegaMenu('')">
              @if (item.children?.length) {
                <div class="header-menu__dropdown-row">
                  <a
                    class="header-menu__item-link header-menu__item-link--dropdown"
                    [attr.href]="item.link"
                    [class.header-menu__item-link--active]="
                      isMenuItemActive(item)
                    "
                    (click)="onParentMenuNavigate(item, $event)">
                    @if (item.icon) {
                      <i
                        class="iconsax header-menu__item-icon"
                        [attr.icon-name]="item.icon"></i>
                    }
                    <span class="header-menu__item-text">
                      {{ item.name | translate }}
                    </span>
                    <i
                      class="iconsax header-menu__item-chevron header-menu__item-chevron--desktop"
                      icon-name="chevron-down"></i>
                  </a>
                  <button
                    type="button"
                    class="header-menu__sub-toggle-btn"
                    [attr.aria-expanded]="isMobileSubmenuOpen(item)"
                    [attr.aria-label]="item.name | translate"
                    (click)="onMobileDropdownToggle($event, item)">
                    <i
                      class="iconsax header-menu__sub-toggle-icon"
                      icon-name="chevron-down"></i>
                  </button>
                </div>
                <ul class="header-menu__sub">
                  @for (child of item.children; track child.link) {
                    <li class="header-menu__sub-item">
                      <a
                        class="header-menu__sub-link"
                        [routerLink]="child.link"
                        (click)="closeMobileNav()">
                        {{ child.name | translate }}
                      </a>
                    </li>
                  }
                </ul>
              } @else {
                <a
                  class="header-menu__item-link"
                  [attr.href]="item.link"
                  [class.header-menu__item-link--active]="
                    isMenuItemActive(item)
                  "
                  (click)="onParentMenuNavigate(item, $event)">
                  @if (item.icon) {
                    <i
                      class="iconsax header-menu__item-icon"
                      [attr.icon-name]="item.icon"></i>
                  }
                  <span class="header-menu__item-text">
                    {{ item.name | translate }}
                  </span>
                </a>
              }
            </li>
          }
        </ul>

        <!-- temporary: disable auctions section quick order section -->
        <!-- quick order -->
        <!-- <a routerLink="/quick-orders" class="header-menu__order-btn">
          <img
            class="order-btn-img"
            ngSrc="assets/icons/order-icon.png"
            width="28"
            height="28"
            alt="" />
          <span class="order-btn-text">{{
            'routes.quickOrders' | translate
          }}</span>
        </a> -->

        @if (!hiddenMegaMenu && productCategories) {
          <section class="mega-menu">
            <pwj-mega-menu [categoriesData]="productCategories"></pwj-mega-menu>
          </section>
        }
      </div>

      <div class="header__trailing">
        <button
          type="button"
          class="header__menu-toggle"
          [attr.aria-expanded]="mobileNavOpen"
          aria-controls="main-navigation"
          [attr.aria-label]="'header.menu' | translate"
          (click)="toggleMobileNav()">
          <i
            class="iconsax header__menu-toggle-icon"
            icon-name="hamburger-menu"></i>
        </button>
        <!-- header login & buy packages -->
        @defer {
          <div class="header-btns">
            @if (user?.username) {
              <pwj-button
                class="header-btns__login"
                [buttonClasses]="'!h-40'"
                variant="secondary"
                icon="user-1"
                iconClasses="!text-3xl"
                (click)="toggleProfileMenu()">
                <span>
                  {{ 'global.account' | translate }}
                </span>
              </pwj-button>
            } @else {
              <pwj-button
                class="header-btns__login"
                [buttonClasses]="'!h-40 yektanet__header-login-btn'"
                matomoClickCategory="Authentication"
                matomoClickAction="Login"
                matomoClickName="Header"
                variant="secondary"
                icon="user-1"
                iconClasses="!text-3xl"
                (click)="toggleProfileMenu()">
                <span>
                  {{ 'header.login' | translate }}
                </span>
              </pwj-button>
            }
          </div>
        } @placeholder (minimum 1500ms) {
          <ngx-skeleton-loader
            count="1"
            class="flex gap-30"
            [theme]="{
              width: '6em',
              height: '2.3em',
              'border-radius': '0.625em',
            }"></ngx-skeleton-loader>

          <!-- packages button -->
          @if (!user.business && user.type === 'PERSONAL') {
            <div>
              <ngx-skeleton-loader
                count="1"
                class="flex gap-30"
                [theme]="{
                  width: '6em',
                  height: '2.3em',
                  'border-radius': '0.625em',
                }"></ngx-skeleton-loader>
            </div>
          }
        }
      </div>

      <!-- profile menu: visibility controlled via class for enter/leave transitions (native [hidden] skips CSS transitions) -->
      <pwj-profile-menu [menuHidden]="hiddenProfileMenu"></pwj-profile-menu>
    </div>
  </section>
</header>

<!-- header search & filters -->
@if (showSearchBar && hiddenMegaMenu && hiddenProfileMenu) {
  <section class="header__search-container container">
    <!-- header filters btn -->
    <pwj-home-search-section [wFull]="true"></pwj-home-search-section>
  </section>
}
